import cache from './Cache';
import system from './System';
import profile from './Profile';
import auth from './Authentication';

export const actions = Object.assign(
  {},
  {
    ...cache.actions,
    ...system.actions,
    ...profile.actions,
    ...auth.actions
  }
);

export const connect = Object.assign(
  {},
  {
    cache: cache.connect,
    system: system.connect,
    profile: profile.connect,
    auth: auth.connect
  }
);

export const reducers = Object.assign(
  {},
  {
    cache: cache.reducer,
    system: system.reducer,
    profile: profile.reducer,
    auth: auth.reducer
  }
);

const redux = {
  actions,
  connect,
  reducers
};

export default redux;



// WEBPACK FOOTER //
// ./src/qoc-redux/index.js